import { connect } from 'react-redux';
import type { AccommodationState, OverrideValues } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { type CheckboxDispatchProps, CheckboxFilter, type CheckboxStateProps } from '@/components/checkboxFilter/CheckboxFilter';
import type { ActionCreator } from 'redux';

export const mapStateToProps = (state: AccommodationState): Omit<CheckboxStateProps, 'facetList'> => ({
    id: 'HotelPageCustomFilter',
    label: 'Vis kun tilbud med',
    checkboxValues: state.filters.hotelPageCustom,
    alwaysExpanded: true,
    horizontal: true,
});

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterHotelPageCustom,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
